import { render, staticRenderFns } from "./PaymentLinkCreditDenied.vue?vue&type=template&id=68bea2c3&scoped=true"
import script from "./PaymentLinkCreditDenied.vue?vue&type=script&lang=js"
export * from "./PaymentLinkCreditDenied.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkCreditDenied.vue?vue&type=style&index=0&id=68bea2c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bea2c3",
  null
  
)

export default component.exports